import 'isomorphic-fetch';
import moment from 'moment';
import { forOwn as _forOwn } from 'lodash';
import { fakeApi } from './fakeApi';
import { getAccessToken, clearCachedToken } from './authService';

import { BOOKING_API_URL } from '../constants';
import { UNAUTHORIZED } from '../constants/httpStatusCodes';

export const AUTHED_USER_URL = `/v1/me/app`;
export const PLANT_URL = `/v1/plant`;
export const PLANT_TYPES_URL = `/v1/plant-types`;
export const PERSONS_URL = `/v1/people`;
export const LOCATIONS_URL = `/v1/locations`;
export const TRAVEL_REASONS_URL = `/v1/travel-reasons`;
export const COST_CENTRES_URL = `/v1/cost-centres`;
export const BOOKINGS_URL = `/v1/bookings`;

export const AVAILABILITY_ROUTE= `availability`;
export const BOOKING_STATE_ROUTE = `state`;
export const BOOKING_TIME_ROUTE = `time`;
export const UNAVAILABLE_TIMES_ROUTE = `allowed-times`;
export const PERSON_SETTINGS_ROUTE = `settings`;

const encodeQueryString = (url, query) => {
    let queryString = ``;
    if (query) {
        queryString = `?`;
        _forOwn(query, (value, key) => {
            queryString += `${key}=${value}&`;
        });
        queryString.trim(`&`);
    }

    return url + queryString;
};

async function callApi(url, options = {}, verb = `GET`) {
    if (process.env.FAKE_API)
        return fakeApi(url, options.data, verb);

    if (options.query)
        url = encodeQueryString(url, options.query);

    const send = async (isRetry) => {
        const accessToken = await getAccessToken();

        const request = {
            method: verb,
            headers: {
                Accept: `application/json`,
                "Content-Type": `application/json`,
            },
        };

        if (accessToken) {
            request.headers[`Authorization`] = `Bearer ${accessToken}`;
        } else {
            // Forms/SUDO session, or no token available: the App cookie authenticates instead
            request.credentials = `include`;
            request.headers[`Authentication-Select`] = `App`;
        }

        if (options.data)
            request.body = JSON.stringify(options.data);

        const response = await fetch(BOOKING_API_URL + url, request);

        // A token can stop being accepted before the expiry we cached it against. Drop it and try
        // once with a fresh one, otherwise every later call keeps sending the same dead token.
        if (response.status === UNAUTHORIZED && accessToken && !isRetry) {
            clearCachedToken();
            return send(true);
        }

        return response;
    };

    const response = await send(false);
    const json = await response.json().catch(() => undefined); // Some api calls don't return json.
    const { ok, status, statusText } = response;
    return { ok, status, statusText, body: json };
}

// api services
export const fetchAuthedUser = () => { return callApi(AUTHED_USER_URL); };
export const fetchPersonSettings = (personId) => { return callApi(`${PERSONS_URL}/${personId}/${PERSON_SETTINGS_ROUTE}`); };
export const fetchPlant = () => { return callApi(PLANT_URL); };
export const fetchPlantTypes = (options) => { return callApi(PLANT_TYPES_URL); };
export const fetchPersons = () => { return callApi(PERSONS_URL); };
export const fetchLocations = () => { return callApi(LOCATIONS_URL); };
export const fetchTravelReasons = (isDeleted) => { return callApi(TRAVEL_REASONS_URL, isDeleted); };
export const fetchCostCentres = () => { return callApi(COST_CENTRES_URL); };
export const fetchBookings = (options) => { return callApi(BOOKINGS_URL, options); };
export const fetchUnavailableTimes = (options, versionedUId) => { return callApi(`${BOOKINGS_URL}/${versionedUId}/${UNAVAILABLE_TIMES_ROUTE}`, options); };
export const fetchAvailablePlant = (options) => { return callApi(`${BOOKINGS_URL}/${AVAILABILITY_ROUTE}`, options); };
export const setBookingState = (options, versionedUId) => { return callApi(`${BOOKINGS_URL}/${versionedUId}/${BOOKING_STATE_ROUTE}`, options, `PATCH`); };
export const setBookingTimes = (options, versionedUId) => { return callApi(`${BOOKINGS_URL}/${versionedUId}/${BOOKING_TIME_ROUTE}`, options, `PATCH`); };
export const createBooking = (options) => { return callApi(BOOKINGS_URL, options, `POST`); };



// WEBPACK FOOTER //
// ./scripts/services/api.js